export default __webpack_public_path__ + "static/media/Letters1_14.31e55d54.png";